import { UserButton } from "./UserMenu";
import { Building2, Sun, Moon } from "lucide-react";
import { useTheme } from "@/providers/ThemeProvider";

/**
 * Standalone shell for the vendor portal. Vendors are external parties with no
 * tenant membership, so they must NOT see the employee AppShell (module rail,
 * company switcher, internal search). This is a minimal header + content frame.
 */
export default function VendorShell({ children }: { children: React.ReactNode }) {
  const { theme, toggleTheme } = useTheme();

  return (
    <div className="min-h-[100dvh] bg-[#f4f6f8] dark:bg-slate-900 flex flex-col">
      <header className="h-14 bg-[#0a2d4a] text-white flex items-center justify-between px-4 sm:px-6 shadow-sm">
        <div className="flex items-center gap-2.5">
          <div className="h-8 w-8 rounded-lg bg-white/10 flex items-center justify-center">
            <Building2 className="h-4.5 w-4.5" />
          </div>
          <div className="leading-tight">
            <p className="text-sm font-semibold">Alea ERP</p>
            <p className="text-[11px] text-white/60">Vendor Portal</p>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <button
            onClick={toggleTheme}
            title={theme === "dark" ? "Switch to light mode" : "Switch to dark mode"}
            className="p-1.5 rounded text-white/60 hover:text-white hover:bg-white/10 transition-colors"
          >
            {theme === "dark" ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
          </button>
          <div className="[&_.cl-userButtonTrigger]:ring-0 [&_.cl-userButtonTrigger]:rounded-full [&_.cl-userButtonTrigger]:hover:opacity-90">
            <UserButton
              appearance={{
                elements: {
                  userButtonPopoverCard: "shadow-xl border border-border rounded-xl overflow-hidden",
                  userButtonPopoverActionButton: "hover:bg-muted/50 rounded-lg",
                  userButtonPopoverActionButtonText: "text-foreground/80 font-medium",
                  userButtonPopoverFooter: "hidden",
                },
              }}
            />
          </div>
        </div>
      </header>
      <main className="flex-1">{children}</main>
    </div>
  );
}
